import React, { useEffect, useState } from "react";
import styles from "./Files.module.scss";
import Dropzone from "react-dropzone";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import ShowDocsModal from "../../../../../components/modals/show-docs-modal/show-docs-modal";
import { getAlertPopUp } from "../../../../../components/helper/helper";
import moment from "moment";
import FileIcon from "../../../../assets/svg/icons/common/file";
import Ellipsis from "../../../../assets/svg/icons/common/Ellipsis";
import DropDown from "../../../../components/DropDown/DropDown";
import Modal from "../../../../components/modal";
import {
  Uploads,
  getFiles,
  DeleteFile,
  getAppFileData,
} from "../../../../../api";
import toast from "react-hot-toast";
import Spinner from "../../../../components/Loaders/Spinner";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import UploadIcon from "../../../../assets/svg/icons/common/upload";
import Download from "../../../../assets/svg/icons/common/Download";
import useCommonStore from "../../../../stores/common";
import useDomainStore from "../../../../stores/domain";
import config from "../../../../../config";

function Files({ appData }) {
  const { isKurvDomain } = useDomainStore();
  const expandAppDetails = useCommonStore((state) => state.expandDetails);

  const [docModal, setDocModal] = useState(false);
  const [docModalFile, setDocModalFile] = useState(null);
  const [isOpenUploadModal, setIsOpenUploadModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFileTitles, setSelectedFileTitles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const openDocModal = async (element) => {
    if (element.id) {
      const fileToShow = ["pdf", "jpg", "jpeg", "png", "svg"];
      const fileNameParts = element.pdf_converted
        ? element.pdf_converted.split(".")
        : element.file.split(".");
      const type =
        fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1] : "";

      if (fileToShow.includes(type)) {
        setDocModalFile({ type, title: element.file, id: element.id });
        setDocModal(true);
      } else {
        try {
          const response = await getAppFileData(element.id);
          if (response.success) {
            const data = response.data;
            const fileNameParts = data.pdf_converted
              ? data.pdf_converted.split(".")
              : data.file.split(".");
            const fileData = {
              type:
                fileNameParts.length > 1
                  ? fileNameParts[fileNameParts.length - 1]
                  : "",
              title: data.file,
              id: data.id,
            };
            setDocModalFile(fileData);
            setDocModal(true);
          } else {
            getAlertPopUp({
              title: "Error!",
              html: response.message,
              error: true,
            });
          }
        } catch (error) {
          getAlertPopUp({ title: "Error!", html: error.message, error: true });
        }
      }
    } else if (element.name && element.path) {
      const filePath = element.path.replaceAll("/", "*");
      setDocModalFile({ type: "pdf", title: element.name, id: filePath });
      setDocModal(true);
    }
  };

  const drop_down_options = [
    {
      text: "Delete",
      type: "normal",
      onClick: () => handleDelete(file.id),
    },
  ];

  const handleDelete = (file) => {
    setConfirmDelete(true);
    setFileToDelete(file);
  };

  const fetchFiles = () => {
    setIsLoading(true);
    getFiles({
      id: appData.id,
    })
      .then((res) => {
        if (res.status) {
          setUploadedFiles(res.uploads);
        } else {
          toast.error("Error while fetching files");
        }
      })
      .catch((err) => {
        toast.error("Error while fetching files");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const onChangeFileTitle = (index, event) => {
    if (event.target.value == "") {
      toast.error("Please select a valid value");
      return;
    }
    let data = selectedFileTitles;
    data[index] = event.target.value;
    setSelectedFileTitles(data);
  };

  const file_title_options = [
    { label: "Please Select", value: "" },
    { label: "Drivers License", value: "Drivers License" },
    { label: "Voided Check", value: "Voided Check" },
    { label: "Bank Statements", value: "Bank Statements" },
    { label: "Processing Statements", value: "Processing Statements" },
    { label: "Financials", value: "Financials" },
    {
      label: "Misc. Business Information",
      value: "Misc. Business Information",
    },
    { label: "Reserve", value: "Reserve" },
    { label: "Inside Photo", value: "Inside Photo" },
    { label: "Outside Photo", value: "Outside Photo" },
    { label: "Marketing Material", value: "Marketing Material" },
    { label: "Rate Review", value: "Rate Review" },
    { label: "Menu for MaxxPay", value: "Menu for MaxxPay" },
    { label: "WHO pre-questionnaire", value: "WHO pre-questionnaire" },
    { label: "Misc.", value: "Misc." },
    { label: "CBD Product Pricing", value: "CBD Product Pricing" },
  ];

  const submit = () => {
    if (selectedFiles.length !== selectedFileTitles.length) {
      toast.error("Please choose file type for all the files");
      return;
    }

    const toastId = toast.loading("Uploading files...", {
      duration: 30 * 1000,
    });
    setIsOpenUploadModal(false);
    const data = new FormData();
    selectedFiles.forEach((file) => {
      data.append("files[]", file, file.name);
    });
    selectedFileTitles.forEach((element) => {
      data.append("title[]", element);
    });

    Uploads(appData.id, data)
      .then((response) => {
        if (response.status) {
          toast.success("Files uploaded successfully", {
            id: toastId,
            duration: 5 * 1000,
          });
          fetchFiles();
        } else {
          toast.error(response.message, { id: toastId, duration: 10 * 1000 });
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!", {
          id: toastId,
          duration: 10 * 1000,
        });
      })
      .finally(() => {
        setSelectedFileTitles([]);
        setSelectedFiles([]);
      });
  };

  const onConfirmClick = () => {
    const toastId = toast.loading("Deleting file...", { duration: 30 * 1000 });
    closeConfirmationModal();
    DeleteFile({
      id: fileToDelete.powerapp_id,
      upload_id: fileToDelete.id,
    })
      .then((res) => {
        if (res.success) {
          toast.success("File deleted successfully", {
            id: toastId,
            duration: 5 * 1000,
          });
        } else {
          toast.error(response.message, { id: toastId, duration: 10 * 1000 });
        }
      })
      .catch((err) => {
        toast.error(response.message, { id: toastId, duration: 10 * 1000 });
      })
      .finally(() => {
        fetchFiles();
      });
  };

  const closeConfirmationModal = () => {
    setConfirmDelete(false);
    setFileToDelete(null);
  };

  const downloadFile = () => {
    const downloadUrl = `${window.location.origin}/download-all-file/${appData.id}`;
    window.open(downloadUrl, "_blank");
  }

  return (
    <div
      className={`${styles.files_tab} ${expandAppDetails ? styles.expanded : ""} ${isKurvDomain ? styles.kurv_theme : ""}`}
    >
      <div className={styles.drag_n_drop_container}>
        <Dropzone
          onDrop={(selectedFiles) => {
            setSelectedFiles(selectedFiles);
            setIsOpenUploadModal(true);
          }}
          minSize={100}
          maxSize={1000000 * 200}
        >
          {({ getRootProps, getInputProps }) => (
            <>
              {expandAppDetails && (
                <h6 className={styles.upload_heading}>Upload Files</h6>
              )}
              <section className={styles.dnd}>
                <div {...getRootProps()} className={styles.dnd_section}>
                  <input {...getInputProps()} />
                  <div className={styles.inner_content}>
                    <UploadIcon />
                    <div>
                      <p>
                        <span className={styles.uploadTextDesktop}>
                          Upload documents by drag and drop or{" "}
                          <span style={{ color: isKurvDomain ? "#22A276" : "#254fe2" }}>click to upload</span>
                        </span>
                        <span className={styles.uploadTextMobile}>Upload documents</span>
                      </p>
                      <p>pdf, xls, docx</p>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        </Dropzone>
      </div>

      <div className={styles.file_lists}>
        {/* Signed files list */}
        <div className={styles.file_list}>
          <div className={styles.head}>
            <h6>Signed files</h6>

            {appData.files.length > 0 && (
              <ButtonIcon 
                textColor={"#254FE2"}
                onClick={() => downloadFile()}            
              >
                <Download color={isKurvDomain ? "#22A276" : "#254FE2"} />
                <span>Download all</span>
              </ButtonIcon>
            )}
          </div>

          <div className={styles.list}>
            {appData.files.map((file, index) => (
              <div key={index} className={styles.file}>
                <div onClick={() => openDocModal(file)}>
                  <FileIcon />
                  <span>{file.name}</span>
                </div>
                <ButtonIcon bgColor={"transparent"} size="small">
                  <Ellipsis />
                </ButtonIcon>
              </div>
            ))}
          </div>
        </div>

        {/* Uploaded files list */}
        <div className={styles.file_list}>
          <div className={styles.head}>
            <h6>Uploaded files</h6>
            {uploadedFiles.length > 0 && (
              <ButtonIcon
                textColor={"#254FE2"}
                onClick={() => downloadFile()}
              >
                <Download color={isKurvDomain ? "#22A276" : "#254FE2"} />
                <span>Download all</span>
              </ButtonIcon>
            )}
          </div>

          {isLoading && (
            <div className={styles.loader}>
              <Spinner />
            </div>
          )}

          {!isLoading && (
            <div className={styles.list}>
              {uploadedFiles.map((file, index) => (
                <div key={index} className={styles.file}>
                  <div onClick={() => openDocModal(file)}>
                    <FileIcon />
                    <span>
                      {file.file} - {file.title} -{" "}
                      {moment(file.created_at).format("MMM D, YYYY | H:mm A")}
                    </span>
                  </div>
                  <div className={styles.fileRowAction}>
                    <DropDown
                      options={[
                        {
                          text: "Delete",
                          type: "normal",
                          onClick: () => handleDelete(file),
                        },
                      ]}
                      size="small"
                    >
                      <Ellipsis />
                    </DropDown>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <ShowDocsModal
        isOpen={docModal}
        close={() => setDocModal(false)}
        file={docModalFile}
      />

      <Modal
        isOpen={isOpenUploadModal}
        onClose={() => setIsOpenUploadModal(false)}
        header={""}
      >
        <h5 className={styles.modal_title}>Select Type of File(s)</h5>
        <div className={styles.upload_file_list}>
          {selectedFiles.map((file, index) => (
            <div key={index} className={styles.upload_file_item}>
              <span className={styles.file_name} title={file?.name || file?.path}>
                {file?.name || file?.path}
              </span>
              <div className={styles.select_type}>
                <select
                  className={styles.input_select}
                  onChange={(e) => onChangeFileTitle(index, e)}
                >
                  {file_title_options.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </div>
        <footer className={styles.footer}>
          <ButtonIcon
            bgColor={"#FFFFFF"}
            textColor={"#4C70EF"}
            onClick={() => {
              setSelectedFileTitles([]);
              setSelectedFiles([]);
              setIsOpenUploadModal(false);
            }}
          >
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFFFFF"
            onClick={() => submit()}
          >
            Submit
          </ButtonIcon>
        </footer>
      </Modal>

      {confirmDelete && (
        <ConfirmationModal
          open={confirmDelete}
          onClose={() => closeConfirmationModal()}
          message={
            "Are you sure you want to delete selected file? You can’t undo this action."
          }
          onConfirmClick={onConfirmClick}
        />
      )}
    </div>
  );
}

export default Files;
